var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slider-item slider-item--top-1" }, [
    _c("h2", { ref: "title", staticClass: "slider-item__title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "slider-item__wrapper" }, [
      _c("div", { ref: "itemIcon", staticClass: "slider-item__icon" }, [
        _c("img", {
          attrs: {
            src:
              "/ressources/logged/img/illustrations/recap2024/slsy-" +
              _vm.icon +
              ".svg",
            alt: "icon",
            width: "72"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "slider-item__icon-expression",
          attrs: {
            src:
              "/ressources/logged/img/illustrations/recap2024/expression.svg",
            alt: "expression",
            width: "20"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { ref: "itemValues", staticClass: "slider-item__info" }, [
        _c("p", { staticClass: "slider-item__value" }, [
          _vm._v(_vm._s(_vm.value))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "slider-item__label" }, [
          _vm._v(_vm._s(_vm.label))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }